const header = qs(".site-header")
const lightHeaderSections = qsa(".light-header")
const mobileNavOverlay = qs('.mobile-nav__overlay')
const mobileNav = qs('.mobile-nav')
const mobileNavCloseButton = qs('.mobile-nav__close')
const menuToggle = qs(".mobile-nav-toggle")
const changePoint = 60


if (lightHeaderSections.length) {
  addScrollListener(async (evt) => {
    const currentSection = await getCurrentSection(lightHeaderSections)
    if(currentSection){
      if(!header.classList.contains('site-header--light')){
        header.classList.add('site-header--light')
      }
    } else {
      if(header.classList.contains('site-header--light')){
        header.classList.remove('site-header--light')
      }
    }
    requestAnimationFrame(()=>{
      header.classList.add('is-visible')
      forceLayout()
      requestAnimationFrame(()=>{
        header.classList.add('has-background')
      })
    })
  })
} else {
  window.addEventListener('DOMContentLoaded', () =>{
    requestAnimationFrame(()=>{
      header.classList.add('is-visible')
      header.classList.add('has-background')
    })
  })
}

function getCurrentSection(els) {
  return new Promise((resolve, reject) => {
    let observer = new IntersectionObserver((entries) => {
      let currentSection = entries
        .filter((entry) => entry.isIntersecting)
        .reduce((acc, curr, index) => {
          return curr.intersectionRect.bottom > changePoint ? curr : acc
        }, null)
      observer.disconnect()
      observer = null

      resolve(currentSection?.target || null)
    })

    els.forEach((el) => observer.observe(el))
  })
}

if (menuToggle) {
  let menuIsOpen = false
  let raf = null

  function open() {
    if( typeof raf !== 'undefined'){
      cancelAnimationFrame(raf)
    }
    menuIsOpen = true
    mobileNavOverlay.classList.add("is-visible")
    mobileNav.classList.add("is-visible")

    raf = requestAnimationFrame(() => {
      mobileNavOverlay.addEventListener("click", close)
    })
  }

  function close() {
    menuIsOpen = false
    mobileNavOverlay.classList.remove("is-visible")
    mobileNav.classList.remove("is-visible")
    mobileNavOverlay.removeEventListener("click", close)
  }

  menuToggle.addEventListener("click", () => {
    if (menuIsOpen) {
      close()
    } else {
      open()
    }
  })

  mobileNavCloseButton.addEventListener('click', close)
}
